import styled from "styled-components";

export const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;  
  gap: 12px;
  
  `; 
